import { FC } from 'react';

import { ChatMessageProps, ChatMessageWrapper } from './ChatMessageWrapper';
import { ParseMessageContent } from '../ParseMessage/ParseMessageContent';

export const ChatMessage: FC<ChatMessageProps> = props => {
  return (
    <ChatMessageWrapper {...props}>
      <ParseMessageContent item={props.item} />
    </ChatMessageWrapper>
  );
};

ChatMessage.displayName = 'ChatMessage';
